<template>
  <div class="container">
    <div class="menu">
      <div class="left">
        <title2 :title="homePageData.moduleName"></title2>
        <div class="content">
          <div class="teacher-list">
            <div class="teacher-item" v-for="item in iconList">
              <img class="avatar" :src="item.authorPortrait">
              <div class="name">{{item.authorName}}</div>
            </div>
          </div>
          <div class="video-content">
            <video :src="videoSrc" controls></video>
            <div class="video-list">
              <div class="video-item" v-for="(item,i) in videoList" style="margin-bottom: 10px">
                <div class="video-item-title" @click="checkVideo(i)">
                  <i class="el-icon-video-play" :class="{'active': activeIndex == i}"></i>
                  <div class="video-tit">{{item.name}}</div>
                </div>
                <div class="video-text" v-show="activeIndex == i">{{item.remark}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="h">{{homePageData2.moduleName}}</div>
        <div class="link">
          <div class="link-item hvr-curl-top-left" v-for="(item,i) in linkList" :style="{backgroundImage:'url('+item.cover+')'}" @click="toDetail(item.goodsId,item.goodsType,item)" v-if="i<6">
            <div class="xm">限免</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import  { getResourceList } from "@/api/index/index.js";
import title2 from './indexTitle2'
export default {
  name: "tribune",

  props:['homePageData','homePageData2','homePageData3'],

  data(){
    return{
      linkList:[

      ],
      activeIndex:0,
      videoSrc: '',
      avatar: require('@/assets/images/default-avatar.png'),
      iconList:[],
      videoList:[]
    }
  },
  components: {title2},
  methods:{
    toDetail(id, type,item) {
      if(item.goodsType == 'looseleafOrtextbook'){
        this.$router.push({
          path: "/bookstore/bookstoreDetail",
          query: {
            goodsId: id,
            goodsType: type,
          },
        });
      }else{
        this.$router.push({
          path: "/willingLearn/bookstoreDetail",
          query: {
            goodsId: id,
            goodsType: type,
          },
        });
      }

    },
    checkVideo(i){
      console.log(i);
      this.activeIndex = i
      this.videoSrc = this.videoList[i].linkAddress
    }
  },
  mounted() {
    getResourceList({featuredId: this.homePageData.id}).then(res=>{
      this.iconList = res.data
    })
    getResourceList({featuredId: this.homePageData2.id}).then(res=>{
      console.log(res);
      this.linkList = res.data
    })
    getResourceList({featuredId: this.homePageData3.id}).then(res=>{
      console.log(res);
      this.videoList = res.data
      this.videoSrc = res.data[0].linkAddress
    })
  }
}
</script>

<style scoped lang="scss">
.container{
  /* 弹性布局 默认水平排列 */
  width: 1400px;
  margin: 0 auto;
  /* 溢出隐藏 */
  .menu{
    display: flex;
    justify-content: space-between;
    margin-bottom: 80px;
    .left{
      width: 1019px;
      .content{
        border: 1px solid #e5e5e5;
        margin-top: 34px;
        .teacher-list{
          width: 100%;
          overflow: hidden;
          display: flex;
          margin-top: 42px;
          .teacher-item{
            margin-left: 33px;
            &:first-of-type{
              margin-left: 22px;
            }
            .avatar{
              width: 110px;
              height: 110px;
              border-radius: 50%;
            }
            .name{
              text-align: center;
              font-size: 18px;
              line-height: 1;
            }
          }
        }
        .video-content{
          display: flex;
          width: 100%;
          margin: 33px 22px 0;
          video{
            width: 545px;
            height: 307px;
          }
          .video-list{
            margin-left: 24px;
            flex: 1;
            align-items: center;
            overflow-y: auto;
            height: 330px;
            .video-item-title{
              cursor: pointer;
              display: flex;
              width: 100%;
              font-size: 24px;
              align-items: center;
              .el-icon-video-play{
                font-size: 30px;
                color: #ababab;
                &.active{
                  color: #128bff;
                }
              }
              .video-tit{
                line-height: 1;
                margin-left: 5px;
                font-weight: 600;
              }
            }
            .active{
              .el-icon-video-play{
                color: #128bff;
              }
            }
            .video-text{
              margin-top: 5px;
              margin-left: 35px;
              margin-bottom: 10px;
              width: 375px;
            }
          }
        }
      }
    }
    .right{
      width: 360px;
      .h{
        line-height: 45px;
        font-size: 30px;
        background-color: #128bff;
        text-align: center;
        border-radius: 0 12px 0 12px;
        color: #fff;
      }
      .link{
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .link-item{
          width: 173px;
          height: 173px;
          background-size: 100% 100%;
          margin-bottom: 17px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          &:nth-child(5),&:nth-child(6){
            margin-bottom: 0;
          }
          .xm{
            background-color: #ffa200;
            width: 100px;
            height: 100px;
            line-height: 175px;
            text-align: center;
            transform: rotate(-45deg);
            color: #fff;
            position: absolute;
            top: -60px;
            left: -60px;
          }
        }
      }
    }
  }
}
</style>